// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": true,
    "raw": "0244180-dirty",
    "hash": "0244180",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "0244180-dirty",
    "semverString": null,
    "version": "0.0.1"
};
/* tslint:enable */
